import { createSelector } from 'reselect';
import keyBy from 'lodash/keyBy';
import get from 'lodash/get';
import mapValues from 'lodash/mapValues';
import { canUseOrIsAuthorized } from 'utils/libraries';

export const getLibraryList = state =>
  state.libraries.list.items.filter(library =>
    canUseOrIsAuthorized(library, state.loggedInUser),
  );
export const getDecodedLibraryList = createSelector(
  [getLibraryList],
  libraryList =>
    libraryList.map(library => ({
      ...library,
      script: atob(library.script),
    })),
);

export const getLibraryOwnerList = createSelector(
  [getLibraryList],
  libraryList =>
    libraryList.map(library => ({
      id: library.id,
      name: library.name,
      owner: library.owner,
      ownerSupervisors: library.ownerSupervisors,
    })),
);

export const getLibraryUsagesMap = createSelector(
  [getLibraryList],
  libraryList =>
    mapValues(keyBy(libraryList, 'id'), library => get(library, 'usage.data')),
);
